export default "__VITE_ASSET__826764b7__"